import { NextSeo } from 'next-seo';
import Head from 'next/head';
import React from 'react';

import { CONTACT } from '@common/constants';
import { Drainage } from '@modules/services/drainage/Drainage';

const TITLE = 'Professional Drain Service in London | Qeeper';
const DESC = `Expert drain service in London—because even your pipes need a little TLC. We offer repairs, unblocking to keep things flowing smoothly. ${CONTACT.PHONE}`;

const URL = 'https://www.qeeper.co.uk/services/drainage';

const SEO_KEYWORDS =
  'drain service, blocked drains, drainage contractors near me, unblock drainage';

const DrainagePage = () => {
  return (
    <>
      <Head>
        <meta name="keywords" content={SEO_KEYWORDS} />
        <link rel="canonical" key="canonical" href={URL} />
        <link rel="alternate" hrefLang="en" href={URL} />
      </Head>
      <NextSeo
        title={TITLE}
        description={DESC}
        canonical={URL}
        openGraph={{
          url: URL,
          title: TITLE,
          description: DESC,
        }}
      />
      <Drainage />
    </>
  );
};

export default DrainagePage;
